import { StyledDiv } from 'theme/commonStyled';
import MuiButton from 'components/Common/MuiButton';
import i18n from 'locales/fa.json';

export const defaultFooterRenderer = (
  handleDefault: () => void,
  handleApply: () => void,
  loading: boolean,
): JSX.Element => (
  <StyledDiv
    display="grid"
    gridTemplateColumns="1fr 2fr"
    gridColumnGap={5}
    p={5}
  >
    <MuiButton variant="white" onClick={handleDefault}>
      {i18n.global.button.default}
    </MuiButton>
    <MuiButton variant="blue" onClick={handleApply} loading={loading}>
      {i18n.global.button.apply}
    </MuiButton>
  </StyledDiv>
);
